import { collectDiagnostics, required } from "./validationUtils.js";
export function validateMasterDataRecord(payload: Record<string, unknown>) { return collectDiagnostics(required(payload.code, "code", "Code"), required(payload.displayName ?? payload.name, "displayName", "Display name")); }
